import { normalize } from "normalizr";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    FEED_UNTRUSTWORTHY_USER_LOAD,
    FeedUntrustworthyUserFetchNormalizedResponse,
    FeedUntrustworthyUserFetchRequestAction,
    feedUntrustworthyUserFetch,
} from "@/mk2/apps/forum/containers/FeedUntrustworthyUser/FeedUntrustworthyUser.actions";
import { ForumMessageSchema, PostEntity, PostSchema } from "@/mk2/apps/forum/schemas";
import { XHRAction, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { CommentEntity, UserSchema } from "@/mk2/schemas";
import { forum_api_feed_untrustworthy_user_url } from "@/mk/urls/functions";

const logger = getLogger("forum/FeedUntrustworthyUser.sagas");

interface ApiResponsePosts {
    body: {
        posts: PostEntity[];
        comments: CommentEntity[];
        hasNext: number;
        hasPrevious: number;
    };
}

function* fetchUntrustworthyUserFeed({
    username,
    after,
    xhr,
}: FeedUntrustworthyUserFetchRequestAction & XHRAction) {
    yield put(feedUntrustworthyUserFetch.request(username, after));

    try {
        const response: ApiResponsePosts = yield call(() =>
            xhr.get(forum_api_feed_untrustworthy_user_url(username), { after }),
        );

        const normalizedResponse: FeedUntrustworthyUserFetchNormalizedResponse = normalize(
            response.body,
            {
                posts: [PostSchema],
                comments: [ForumMessageSchema],
                user: UserSchema,
            },
        );

        yield put(
            feedUntrustworthyUserFetch.success(
                username,
                after,
                response.body.hasNext,
                response.body.hasPrevious,
                normalizedResponse,
            ),
        );
    } catch (error) {
        logger.error(error);
        yield put(feedUntrustworthyUserFetch.failure(username, after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(FEED_UNTRUSTWORTHY_USER_LOAD, fetchUntrustworthyUserFeed)]);
}
